import { API } from "."
import {
  ReadActivityIntervalSummaryParams,
  ReadActivityIntervalSummaryResponse,
  ReadDailyCSVDataParams,
  ReadDailyCSVDataResponse,
  ReadPlayerActivitySummaryParams,
  ReadPlayerActivitySummaryResponse,
  ReadPlayerSessionSummaryParams,
  ReadPlayerSessionSummaryResponse,
  ReadReportTemplateDetailResponse,
  ReadReportTemplatesParams,
  ReadReportTemplatesResponse,
  ReadSessionIntervalSummaryParams,
  ReadSessionIntervalSummaryResponse,
  ReadSessionPlayerSummaryParams,
  ReadSessionPlayerSummaryResponse,
  ReadTrendPlayerActivitySummaryParams,
  ReadTrendPlayerActivitySummaryResponse,
  ReadTrendPlayerCSVDataParams,
  ReadTrendPlayerCSVDataResponse,
  ReadTrendPlayerSummaryParams,
  ReadTrendPlayerSummaryResponse,
  ReadTrendGroupSummaryParams,
  ReadDailySessionGroupSummaryParams,
  ReadDailyActivityGroupSummaryParams,
  ReadTrendGroupSummaryResponse,
  UpsertReportTemplatePayload,
  UpsertReportTemplateResponse,
  ReadPlayerActivityActionDetailsParams,
  ReadPlayerSessionActionDetailsParams,
  ReadPlayerActivityActionDetailsResponse,
  ReadPlayerSessionActionDetailsResponse,
  ReadPlayerActivityAction18ZoneResponse,
  ReadPlayerSessionAction18ZoneResponse,
  ReadPlayerActivityAction18ZoneParams,
  ReadPlayerSessionAction18ZoneParams,
  ReadPlayerActivityLocation18ZoneResponse,
  ReadPlayerSessionLocation18ZoneResponse,
  ReadPlayerActivityLocation18ZoneParams,
  ReadPlayerSessionLocation18ZoneParams,
  ReadPlayerActivityLocationHeatmapParams,
  ReadPlayerSessionLocationHeatmapParams,
  ReadPlayerSessionLocationHeatmapResponse,
  ReadPlayerActivityLocationHeatmapResponse,
  ReadPlayerActivityFormationMapParams,
  ReadPlayerActivityFormationMapResponse,
  ReadPlayerSessionFormationMapParams,
  ReadPlayerSessionFormationMapResponse,
  ReadPlayerPerformanceParams,
  ReadPlayerPerformanceResponse,
  ReadPlayerPerformanceActionsParams,
  ReadPlayerPerformanceActionsResponse,
  ReadRawDataPlayersParams,
  ReadRawDataPlayersResponse,
  ReadRawDataActivityParams,
  ReadRawDataActivityResponse,
} from "@/types/report"
import { makeUrl, makeUrlParams } from "@/utils/helper"
import { ApiResponse } from "./type"

/* 세션별 선수 데이터 집계 조회 */
export async function readSessionPlayerSummary(params: ReadSessionPlayerSummaryParams) {
  const { sessions, players } = params
  const url = makeUrl({ sessions: sessions, players: players })

  return await API.get<ReadSessionPlayerSummaryResponse>(`/reports/v2${url}/summary/session`)
}

/* 선수별 세션 데이터 집계 조회 */
export async function readPlayerSessionSummary(params: ReadPlayerSessionSummaryParams) {
  const { sessions, players } = params
  const url = makeUrl({ sessions: sessions, players: players })

  return await API.get<ReadPlayerSessionSummaryResponse>(`/reports/v2${url}/summary/player`)
}

/* 선수별 액티비티 데이터 집계 조회 */
export async function readPlayerActivitySummary(params: ReadPlayerActivitySummaryParams) {
  const { activities, players } = params
  const url = makeUrl({ activities: activities, players: players })

  return await API.get<ReadPlayerActivitySummaryResponse>(`/reports/v2${url}/summary/player`)
}

/* Report Actions */
export async function readPlayerActivityActionDetails(
  params: ReadPlayerActivityActionDetailsParams,
) {
  const { activities, players, actionType } = params
  const url = makeUrl({ activities: activities, players: players })

  return await API.get<ReadPlayerActivityActionDetailsResponse>(
    `/reports/v2${url}/actions/${actionType}`,
  )
}

export async function readPlayerSessionActionDetails(params: ReadPlayerSessionActionDetailsParams) {
  const { sessions, players, actionType } = params
  const url = makeUrl({ sessions: sessions, players: players })

  return await API.get<ReadPlayerSessionActionDetailsResponse>(
    `/reports/v2${url}/actions/${actionType}`,
  )
}

export async function readPlayerActivityAction18Zone(params: ReadPlayerActivityAction18ZoneParams) {
  const { activities, players, actionType } = params
  const url = makeUrl({ activities: activities, players: players })

  return await API.get<ReadPlayerActivityAction18ZoneResponse>(
    `/reports/v2${url}/actions/${actionType}/18-zone`,
  )
}

export async function readPlayerSessionAction18Zone(params: ReadPlayerSessionAction18ZoneParams) {
  const { sessions, players, actionType } = params
  const url = makeUrl({ sessions: sessions, players: players })

  return await API.get<ReadPlayerSessionAction18ZoneResponse>(
    `/reports/v2${url}/actions/${actionType}/18-zone`,
  )
}

export async function readPlayerActivityFormationMap(params: ReadPlayerActivityFormationMapParams) {
  const { activities, players } = params
  const url = makeUrl({ activities: activities, players: players })

  return await API.get<ReadPlayerActivityFormationMapResponse>(`/reports/v2${url}/formation`)
}

export async function readPlayerSessionFormationMap(params: ReadPlayerSessionFormationMapParams) {
  const { sessions, players } = params
  const url = makeUrl({ sessions: sessions, players: players })

  return await API.get<ReadPlayerSessionFormationMapResponse>(`/reports/v2${url}/formation`)
}

export async function readPlayerActivityLocation18Zone(
  params: ReadPlayerActivityLocation18ZoneParams,
) {
  const { activities, players } = params
  const url = makeUrl({ activities: activities, players: players })

  return await API.get<ReadPlayerActivityLocation18ZoneResponse>(
    `/reports/v2${url}/location/18-zone`,
  )
}

export async function readPlayerSessionLocation18Zone(
  params: ReadPlayerSessionLocation18ZoneParams,
) {
  const { sessions, players } = params
  const url = makeUrl({ sessions: sessions, players: players })

  return await API.get<ReadPlayerSessionLocation18ZoneResponse>(
    `/reports/v2${url}/location/18-zone`,
  )
}

export async function readPlayerActivityLocationHeatmap(
  params: ReadPlayerActivityLocationHeatmapParams,
) {
  const { activities, players } = params
  const url = makeUrl({ activities: activities, players: players })

  return await API.get<ReadPlayerActivityLocationHeatmapResponse>(
    `/reports/v2${url}/location/heatmap`,
  )
}

export async function readPlayerSessionLocationHeatmap(
  params: ReadPlayerSessionLocationHeatmapParams,
) {
  const { sessions, players } = params
  const url = makeUrl({ sessions: sessions, players: players })

  return await API.get<ReadPlayerSessionLocationHeatmapResponse>(
    `/reports/v2${url}/location/heatmap`,
  )
}

/* 세션 데이터 인터벌 집계 */
export async function readSessionIntervalSummary(params: ReadSessionIntervalSummaryParams) {
  const { eventIds, players, interval } = params
  const sessionUrl = makeUrl({
    sessions: eventIds,
    players,
    "summary/interval": interval,
  })

  return await API.get<ReadSessionIntervalSummaryResponse>(`/reports/v2${sessionUrl}`)
}

/* 액티비티 데이터 인터벌 집계 */
export async function readActivityIntervalSummary(params: ReadActivityIntervalSummaryParams) {
  const { eventIds, players, interval } = params
  const activityUrl = makeUrl({
    activities: eventIds,
    players,
    "summary/interval": interval,
  })

  return await API.get<ReadActivityIntervalSummaryResponse>(`/reports/v2${activityUrl}`)
}

/* CSV 생성을 위한 선수별 액티비티, 세션 데이터 집계 조회 */
export async function readDailyCSVData({
  idfActivityList,
  idfSessionList,
  idfPlayerList,
}: ReadDailyCSVDataParams) {
  const url = makeUrl({
    activities: idfActivityList,
    sessions: idfSessionList,
    players: idfPlayerList,
  })

  return await API.get<ReadDailyCSVDataResponse>(`/reports/v2${url}/summary/daily/csv/player`)
}

/* CSV 생성을 위한 선수별 액티비티 데이터 누적 집계 조회 */
export async function readTrendPlayerCSVData({
  idfActivityList,
  idfPlayerList,
}: ReadTrendPlayerCSVDataParams) {
  const url = makeUrl({ activities: idfActivityList, players: idfPlayerList })

  return await API.get<ReadTrendPlayerCSVDataResponse>(`/reports/v2${url}/summary/trend/csv/player`)
}

/* 선수별 액티비티 누적 집계 */
export async function readTrendPlayerSummary({
  idfActivityList,
  idfPlayerList,
}: ReadTrendPlayerSummaryParams) {
  const urlParams = makeUrlParams({ activities: idfActivityList, players: idfPlayerList })

  return await API.get<ReadTrendPlayerSummaryResponse>(
    `/reports/v2${urlParams}/summary/trend/player`,
  )
}

/* 액티비티별 선수 데이터 누적 집계 조회 */
export async function readTrendPlayerActivitySummary({
  idfActivityList,
  idfPlayerList,
}: ReadTrendPlayerActivitySummaryParams) {
  // 선택한 액티비티 데이터가 없을 경우 빈 데이터를 반환
  if (!idfActivityList.length) {
    return new Promise<ApiResponse<ReadTrendPlayerActivitySummaryResponse>>((resolve) =>
      resolve({ response: [], success: true }),
    )
  }
  const urlParams = makeUrlParams({ activities: idfActivityList, players: idfPlayerList })

  return await API.get<ReadTrendPlayerActivitySummaryResponse>(
    `/reports/v2${urlParams}/summary/trend/activity`,
  )
}

/* 그룹별 데이터 누적 집계 조회 (Custom Table) */
export async function readTrendGroupSummary({
  idfActivityList,
  idfPlayerList,
  groupKey1,
  groupKey2,
}: ReadTrendGroupSummaryParams) {
  if (!idfActivityList.length || !groupKey1) {
    return new Promise<ApiResponse<ReadTrendGroupSummaryResponse>>((resolve) =>
      resolve({ response: [], success: true }),
    )
  }
  const urlParams = makeUrlParams({ activities: idfActivityList, players: idfPlayerList })

  return await API.get<ReadTrendGroupSummaryResponse>(
    `/reports/v2${urlParams}/summary/trend/group`,
    {
      params: {
        groupKey1,
        ...(groupKey2 && { groupKey2 }),
      },
    },
  )
}

/* 세션 단위 그룹 집계 조회 (Daily 리포트 세션 모드의 Custom Table) — 응답 형태는 trend/group 과 동일 */
export async function readDailySessionGroupSummary({
  idfSessionList,
  idfPlayerList,
  groupKey1,
  groupKey2,
}: ReadDailySessionGroupSummaryParams) {
  if (!idfSessionList.length || !groupKey1) {
    return new Promise<ApiResponse<ReadTrendGroupSummaryResponse>>((resolve) =>
      resolve({ response: [], success: true }),
    )
  }
  const urlParams = makeUrlParams({ sessions: idfSessionList, players: idfPlayerList })

  return await API.get<ReadTrendGroupSummaryResponse>(
    `/reports/v2${urlParams}/summary/daily/group`,
    {
      params: {
        groupKey1,
        ...(groupKey2 && { groupKey2 }),
      },
    },
  )
}

/* 액티비티 단위 그룹 집계 조회 (Daily 리포트 액티비티 모드의 Custom Table)
   액티비티 전체 기준이라 세션 크롭이 반영되지 않는다 — 같은 화면의 Action Map·Stats 와 같은 기준 (#104).
   trend/group 은 세션 요약을 읽어 크롭이 반영되므로 Daily 액티비티 모드에서는 쓰지 않는다. */
export async function readDailyActivityGroupSummary({
  idfActivityList,
  idfPlayerList,
  groupKey1,
  groupKey2,
}: ReadDailyActivityGroupSummaryParams) {
  if (!idfActivityList.length || !groupKey1) {
    return new Promise<ApiResponse<ReadTrendGroupSummaryResponse>>((resolve) =>
      resolve({ response: [], success: true }),
    )
  }
  const urlParams = makeUrlParams({ activities: idfActivityList, players: idfPlayerList })

  return await API.get<ReadTrendGroupSummaryResponse>(
    `/reports/v2${urlParams}/summary/daily/group`,
    {
      params: {
        groupKey1,
        ...(groupKey2 && { groupKey2 }),
      },
    },
  )
}

// TODO
/* Report Templates */

/* 팀 리포트 템플릿 조회 */
export async function readReportTemplates(params: ReadReportTemplatesParams) {
  return await API.get<ReadReportTemplatesResponse>(`/report-templates`, {
    params,
  })
}

/* 팀 리포트 템플릿 상세 조회 */
export async function readReportTemplateDetail(idfReportTemplate: number) {
  return await API.get<ReadReportTemplateDetailResponse>(`/report-templates/${idfReportTemplate}`)
}

/* 리포트 템플릿 설정 내용 수정 */
export async function upsertReportTemplate(payload: UpsertReportTemplatePayload) {
  return await API.put<UpsertReportTemplateResponse>(`/report-templates/${payload.idfTemplate}`, {
    name: payload.name,
    content: payload.content,
  })
}

/* 선수별 액티비티 퍼포먼스 데이터 조회 */
export async function readPlayerActivityPerformance(params: ReadPlayerPerformanceParams) {
  const { idfActivity, idfPlayer, dataTypes } = params
  const url = makeUrlParams({ activities: idfActivity, players: idfPlayer })

  return await API.get<ReadPlayerPerformanceResponse>(`/reports/v2${url}/performance`, {
    params: {
      dataTypes: dataTypes.join(","),
    },
  })
}

/* 선수별 액티비티 액션 목록 조회 */
export async function readPlayerActivityActions(params: ReadPlayerPerformanceActionsParams) {
  const { idfActivity, idfPlayer, actionTypes } = params
  const url = makeUrlParams({ activities: idfActivity, players: idfPlayer })

  return await API.get<ReadPlayerPerformanceActionsResponse>(`/reports/v2${url}/actions`, {
    params: {
      actionTypes: actionTypes.join(","),
    },
  })
}

/* 리포트 템플릿 마지막 사용 시간 갱신 */
export async function updateReportTemplateLastUsed(
  idfReportTemplate: number,
  reportType: "daily" | "trend",
) {
  return await API.put(`/report-templates/${idfReportTemplate}/last-used`, null, {
    params: { reportType },
  })
}

/* Raw Data Export - 선수별 데이터 다운로드 URL 조회 */
export async function readRawDataPlayers({ idfActivity, idfPlayers }: ReadRawDataPlayersParams) {
  return await API.get<ReadRawDataPlayersResponse>(
    `/reports/v2/activities/${idfActivity}/players/${idfPlayers.join(",")}/raw`,
  )
}

/* Raw Data Export - 액티비티 전체 데이터 다운로드 URL 조회 */
export async function readRawDataActivity({ idfActivity }: ReadRawDataActivityParams) {
  return await API.get<ReadRawDataActivityResponse>(`/reports/v2/activities/${idfActivity}/raw`)
}
